import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-document-list-tkt-result.actions';
import { GetDocumentListTktResultState } from './get-document-list-tkt-result.state';

/**
 * getDocumentListTktResult initial state
 */
export const getDocumentListTktResultInitialState: GetDocumentListTktResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetDocumentListTktResult Store
 */
export const getDocumentListTktResultReducerFeatures: ReducerTypes<GetDocumentListTktResultState, ActionCreator[]>[] = [
  on(actions.setGetDocumentListTktResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetDocumentListTktResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetDocumentListTktResult, () => getDocumentListTktResultInitialState),

  on(actions.cancelGetDocumentListTktResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetDocumentListTktResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(actions.setGetDocumentListTktResultFromApi, actions.updateGetDocumentListTktResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetDocumentListTktResult Store reducer
 */
export const getDocumentListTktResultReducer = createReducer(
  getDocumentListTktResultInitialState,
  ...getDocumentListTktResultReducerFeatures
);
